import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  NavBarStateContext,
  HomepageStateContext,
  FirstAndLastNameContext,
  IsSigningOutContext,
  ReloadHomepageContext,
  ErrorMessageContext,
  HasOldSandboxContext,
  NavWidthContext,
} from './contextLib';

export default function ContextWrapper({ children }) {
  const [navBarState, setNavBarState] = useState({ userType: 'client' });
  const [globalHomepageState, setGlobalHomepageState] = useState('');
  const [globalFirstAndLastName, setGlobalFirstAndLastName] = useState(null);
  const [isSigningOut, setIsSigningOut] = useState(false);
  const [reloadHomepage, setReloadHomepage] = useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState(null);
  const [hasOldSandbox, setHasOldSandbox] = useState(false);
  const [navWidth, setNavWidth] = useState(null);

  const navBarStateProviderValue = useMemo(() => ({ navBarState, setNavBarState }), [navBarState]);
  const globalHomepageStateProviderValue = useMemo(() => ({ globalHomepageState, setGlobalHomepageState }), [globalHomepageState]);
  const globalFirstAndLastNameProviderValue = useMemo(() => ({ globalFirstAndLastName, setGlobalFirstAndLastName }), [globalFirstAndLastName]);
  const isSigningOutProviderValue = useMemo(() => ({ isSigningOut, setIsSigningOut }), [isSigningOut]);
  const reloadHomepageProviderValue = useMemo(() => ({ reloadHomepage, setReloadHomepage }), [reloadHomepage]);
  const showErrorMessageProviderValue = useMemo(() => ({ showErrorMessage, setShowErrorMessage }), [showErrorMessage]);
  const hasOldSandboxProviderValue = useMemo(() => ({ hasOldSandbox, setHasOldSandbox }), [hasOldSandbox]);
  const navWidthProviderValue = useMemo(() => ({ navWidth, setNavWidth }), [navWidth]);

  return (
    <NavBarStateContext.Provider value={navBarStateProviderValue}>
      <HomepageStateContext.Provider value={globalHomepageStateProviderValue}>
        <HasOldSandboxContext.Provider value={hasOldSandboxProviderValue}>
          <ErrorMessageContext.Provider value={showErrorMessageProviderValue}>
            <FirstAndLastNameContext.Provider value={globalFirstAndLastNameProviderValue}>
              <IsSigningOutContext.Provider value={isSigningOutProviderValue}>
                <ReloadHomepageContext.Provider value={reloadHomepageProviderValue}>
                  <NavWidthContext.Provider value={navWidthProviderValue}>
                    {children}
                  </NavWidthContext.Provider>
                </ReloadHomepageContext.Provider>
              </IsSigningOutContext.Provider>
            </FirstAndLastNameContext.Provider>
          </ErrorMessageContext.Provider>
        </HasOldSandboxContext.Provider>
      </HomepageStateContext.Provider>
    </NavBarStateContext.Provider>
  );
}

ContextWrapper.propTypes = { children: PropTypes.element };
